module.exports = __webpack_public_path__ + "static/8-fe3b42b8125610055b5e44e4b926a8a9.png";